import React from "react";
import {keycloak} from "./index";
import {useUser} from "./components/user";

export default function StaffOnly(props: React.PropsWithChildren) {
	const user = useUser(keycloak!);

	if (user) return props.children;

	else return <section id="staff-only">
		<h1>Zutritt nur für AkroServices Personal.</h1>
		<p>Bitte melden Sie sich mit einem AkroServices Benutzer an um fortzufahren.</p>

		<button onClick={() => keycloak!.login()}>Anmelden</button>

		<footer id="footer">
			<div className='disclaimer'>
				Diesem Werkzeug ist ausschließlich der internen Gebrauch von AkroServices Mitarbeitern gestattet.
				Unbefugten ist der Zugriff verboten.
				Falls Sie doch unerwartet Zugriff bekommen haben, bitten wir Sie dies dringend uns zu mitzuteilen.
				<br />
				<a href='mailto:info@akroservices.de' className='danger'>Zugriff melden</a>
			</div>
			<nav>

			</nav>
		</footer>
	</section>
}